import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import EcoProLogo from "../../../../assets/images/benefitofsuppliespage/ecopro-logo.svg";
import ConnectLogo from "../../../../assets/images/benefitofsuppliespage/connect-logo.svg";
import BtnWhiteArrowIcon from "../../../../assets/images/benefitofsuppliespage/button-arrow-mark-white.svg";
import './BOSCardCarousel.css';
import HardwareInclusiveContent from "../HardwareInclusiveContent";
import EcoProButton from "../../../../components/shared/button/button";
import { BMC_SHENLONG_SERVICE_TYPES, featureSwitchName, NATIVE_APP_SELECTION_ATTRIBUTE } from "../../../../constants/AppConstants";
import Confirmation from "../../Shared/BOSCardCarousel/BPlus/Confirmation/Confirmation";
import Overview from "../../Shared/BOSCardCarousel/BPlus/Overview/Overview";
import { Trans } from "react-i18next";
import { shenlongPageDisplayInfoContext } from "../BenefitOfSuppliesMain";
import { BOSPageContext } from "../../BenefitOfSuppliesWrapper";
import { getTrailContentBOSPage, IsHWIncServiceNativeApp } from "../../../../constants/AppMethod";
import { BROTHER_PLUS_DISPLAY_CONTENT } from "../Bplus/Constants";
import convertHtmlToReact from "@hedgedoc/html-to-react";
import SkipModal from "../SkipModal/SkipModal";
import EcoProBenefitPoints from "../EcoPro/BenefitPoints/BenefitPoints";
import LearnMore from "../LearnMore/LearnMore";

const BOSCardCarousel = (props) => {
    const { t } = useTranslation(["translation"]);
    const { handleBPlusDisplayContent, bPlusDisplayContent } = props;
  
    const {
          isEcoProOnly,
          isBplusOnly,
          modalState,
          toggleModal,
          handleModalState,
          handleGetStarted
        } = useContext(BOSPageContext);
    
    const {
            planResult,
            planCurrency,
            planPrice,
            featureSwitchValues
        } = useContext(shenlongPageDisplayInfoContext);
    
    const isHWInc = IsHWIncServiceNativeApp();
    const PromotionBanners = featureSwitchValues?.[featureSwitchName.PROMOTION_BANNERS];
    const BonusPages = featureSwitchValues?.[featureSwitchName.BONUS_PAGES];
    const isBplusConfirmationCardActive = (bPlusDisplayContent === BROTHER_PLUS_DISPLAY_CONTENT.CONFIRMATION) ? true : false;
    const [candisplaySkip, setDisplaySkipOption] = useState(true);
  
    const goBackToBplusOverviewSlide = () => {
        handleBPlusDisplayContent(BROTHER_PLUS_DISPLAY_CONTENT.OVERVIEW)
    }

    const displayEcoProService = isEcoProOnly || isHWInc || (!isEcoProOnly && !isBplusOnly);
    const displayBplusService = !isHWInc && (isBplusOnly || (!isEcoProOnly && !isBplusOnly));

    const settings = {
    // Desktop: centered slide, one slide at a time
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    speed: 500,
    dots: !isBplusConfirmationCardActive,
    arrows: false,
    swipe: !isBplusConfirmationCardActive,
    draggable: !isBplusConfirmationCardActive,
    accessibility: !isBplusConfirmationCardActive,
    touchMove: !isBplusConfirmationCardActive,
    centerMode: true,
    centerPadding: "36px",
    beforeChange: (oldIndex, newIndex) => {
        if (oldIndex === 1 && newIndex === 0) {
            handleBPlusDisplayContent(BROTHER_PLUS_DISPLAY_CONTENT.OVERVIEW);
        }
    },
    afterChange: (index) => {
        setDisplaySkipOption((index === 1) ? false :  true);
    },
    responsive: [
        // Tablet
        {
        breakpoint: 1025,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: true,
            centerPadding: "40px",
        },
        },
        // Mobile
        {
        breakpoint: 769, // up to 768px
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: true,
            centerPadding: "32px", 
        },
        },
        // Small phones
        {
        breakpoint: 426, // up to 425px
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: true,
            centerPadding: "24px",
        },
        },
    ],
    };

    return (
        <>
            <div className="bos-card-carousel-header-wrapper">
                {
                    (bPlusDisplayContent === BROTHER_PLUS_DISPLAY_CONTENT.CONFIRMATION)
                    ? <h1>{t('BENEFIT_PAGE_REDESIGN.HEADER.BPLUS_CONFIRMATION_SLIDE_TITLE')}</h1>
                    : null
                }
            </div>
            <div className="benefit-carousel">
                <Slider {...settings}>
                    {
                        (displayBplusService) &&
                        <div className="bplus bos-carousel-card-wrapper">
                        <div className="bos-carousel-card-inner-wrapper bplus">
                        <div className="banner-image-container">
                            <img src={ConnectLogo} title="connect-logo" alt="connect-logo"/>
                        </div>
                        <div className="page-content-container">
                            { 
                                (isBplusConfirmationCardActive)
                                ? <Confirmation />
                                : <Overview handleDisplayContent = {handleBPlusDisplayContent}/>
                            }
                        </div>
                        </div>
                        </div>
                    }

                    {
                        (displayEcoProService) && 
                        <div className="ecopro bos-carousel-card-wrapper">
                        <div className="bos-carousel-card-inner-wrapper ecopro">
                            <div className="banner-image-container">
                                <img src={EcoProLogo} title="ecopro-logo" alt="ecopro-logo" />
                            </div>
                            {
                                (isHWInc)
                                    ? <div className="page-content-container hwinc-ecopro-bos-wrapper">
                                        <HardwareInclusiveContent />
                                        <div className="view-plan-container">
                                            <EcoProButton
                                                cname="get-started-btn"
                                                onBtnClick={() => handleGetStarted(NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE)}
                                            >
                                                {t('ECOPRO_BTNS.CONTINUE')}
                                            </EcoProButton>
                                        </div>
                                    </div>
                                    : <div className="page-content-container">
                                        <h1>{t('ECOPRO_BENEFIT_OF_SUPPLIES_PAGE.HEADER')}</h1>
                                        <div className="benefit-points">
                                            <EcoProBenefitPoints />
                                        </div>
                                        <div className="benefit-desc">
                                            {convertHtmlToReact(t('BENEFITS_OF_SUPPLIES.PROMOTION_CONTENT'), [true])}
                                        </div>
                                        <div className="trial-content-wrapper">
                                            {getTrailContentBOSPage(PromotionBanners, BonusPages)}
                                        </div>
                                        {
                                            (!planResult?.error) && <div className="benefit-desc price-info">
                                                 <Trans i18nKey="BENEFITS_OF_SUPPLIES.STARTING_FROM" planCurrency={planCurrency} planPrice={planPrice}>
                                                    Starting from as low as <span>{{planPrice}}</span>. T&Cs apply.
                                                </Trans>
                                            </div>
                                        }
                                        <div className="view-plan-container">
                                            <EcoProButton cname="get-started-btn" onBtnClick={() => handleGetStarted(NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE)}>
                                                {
                                                    (isHWInc)
                                                    ? t('ECOPRO_BTNS.CONTINUE')
                                                    : BonusPages ? t("EASY_SETUP.BANNER.LINE1_BONUS") 
                                                    : t("EASY_SETUP.BANNER.LINE1")
                                                }
                                                <span><img src={BtnWhiteArrowIcon} alt='white-arrow' title="white-arrow"/></span>
                                            </EcoProButton>
                                        </div>
                                        <div className="learn-more-container">
                                           <LearnMore type={BMC_SHENLONG_SERVICE_TYPES.ECOPRO}/>
                                        </div>
                                    </div>
                            }
                            <SkipModal
                                modalState={modalState}
                                toggleModal={toggleModal}
                                handleBackBtn={() => handleModalState(false)}
                                handleContinueBtn={handleGetStarted}
                            />
                        </div>
                        </div>
                    }
                    
                </Slider>
            </div>
            <div className="skip-for-now-container">
                {
                
                    (isBplusConfirmationCardActive)
                    ? <EcoProButton cname="may-be-later-btn" onBtnClick={() => goBackToBplusOverviewSlide()}>{t('BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.SKIP_FOR_NOW_NEW')}</EcoProButton>
                    : (!isHWInc && candisplaySkip) && 
                        <EcoProButton cname="may-be-later-btn" onBtnClick={() => handleModalState(true)}>{t('BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.SKIP_FOR_NOW_NEW')}</EcoProButton>
                }
            </div>
        </>
    );  
}

export default BOSCardCarousel;